<!--
 * @Author: 范向玲
 * @Date: 2023-05-30 13:40:08
 * @LastEditTime: 2026-01-15 15:40:44
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @Description: 贸易量数据管理--详情表格
 * @FilePath: \web\src\components\DataManagement\reservesLibrary\component\detail.vue
-->
<template>
  <section class="reservesLibrary-detail-container">
    <section class="detail-header">
      <section class="detail-infotext">
        <section class="detail-infotext-item" v-for="(item, index) in headerInfo" :key="index">
          <section class="detail-infotext-label">{{ item.label }}：</section>
          <section class="detail-infotext-value">{{ item.value }}</section>
        </section>
      </section>
      <div class="crud-wrapper">
        <div class="crud-item" @click="isCrudEdit ? selectEdit() : selectEditSumbit()"
          :class="selectedKeys.length > 0 || !isCrudEdit ? 'crud-item-abled' : 'crud-item-disabled'">
          {{ isCrudEdit ? '编辑' : '确认' }}
        </div>

        <!-- <div
          class="crud-item"
          @click="selectEditSumbit()"
          :class="!isCrudEdit ? 'crud-item-abled' : 'crud-item-disabled'"
        >
          确认
        </div> -->

        <div class="crud-item" @click="selectDel()"
          :class="selectedKeys.length > 0 ? 'crud-item-abled' : 'crud-item-disabled'">
          删除
        </div>
      </div>
    </section>
    <a-table rowKey="id" class="trend-detail-table" :dataSource="detailPages" :loading="detailPagesLoading"
      :columns="detailColumns" @change="detailChangePage" :row-selection="detailRowSelection" :scroll="{ y: '96%' }"
      :pagination="detailPaginationOption">
      <template #serial="{ index }">{{ index + 1 }}</template>
      <template v-for="col in ['value', 'country', 'year', 'remark']" #[col]="{ text, record }" :key="col">
        <template v-if="!record.isEdit">
          <span>{{ text }}</span>
        </template>
        <template v-else>
          <a-input v-show="col === 'value' || col === 'remark' || col === 'country' || col === 'year'"
            v-model:value="record[col]" />
          <!-- <a-date-picker v-show="col === 'year'" v-model:value="record.date" valueFormat="YYYY" picker="year"/> -->
        </template>
      </template>
      <template #action="{ record, index }">
        <section class="action-icons">
          <i v-for="(item, i) in detailTableOperationList" :key="i" v-bind="item.option"
            @click="item.click(record, index)">
          </i>
        </section>
      </template>
    </a-table>
    <Modal :option="confirmModalConf" @confirm="confirm" @close="close">
      <template v-slot:main> </template>
    </Modal>
  </section>
</template>

<script setup>
import { message } from 'ant-design-vue';
import { useStore } from 'vuex';
import { ref, reactive, computed, toRefs, watch, onMounted, onBeforeMount, defineProps } from 'vue';
import { detailTableConfig } from './config.js';
import { GET_RESERVERS_LIBRARY_DETAIL_PAGE } from '@/store/modules/actions/tradeQuantity.js';
import { deleteReservesApi, editReservesApi } from '@/api/dataManagement/ccxm';
import config from '@/config/config';
import Modal from '@/components/lib/Modal/modal1.vue';
import moment from 'moment';

const props = defineProps({
  headerInfo: {
    type: Array,
  },
  code: {
    type: String,
  },
});

const detailColumns = detailTableConfig;

detailColumns[1].title = props.code === 'XFL' ? '消费量' : props.code === 'PL' ? '产量' : '储量'

const { state, dispatch: storeDispatch, commit: storeCommit } = useStore();
// state
const reservesLibraryState = computed(() => state.reservesLibrary);
const { detailTotalCount, detailRequestParams, detailPages, detailPagesLoading } = toRefs(reservesLibraryState.value);

// 重写commit
const commit = (space, methods, params) => storeCommit(`${space || 'reservesLibrary'}/${methods}`, params);
// 重写dispatch
const dispatch = (space, methods, params) => storeDispatch(`${space || 'reservesLibrary'}/${methods}`, params);

const isCrudEdit = ref(true); // 编辑、确认按钮状态

// 确认弹窗 公用
const confirmModalConf = reactive({
  loading: false,
  visible: false,
  title: '',
  confirm: null,
  remark: '',
  callback: null,
  showRemark: true,
  showUpload: false,
  selectValue: [],
});

const selectedKeys = ref([]); // 表格选中id

const detailPaginationOption = computed(() => ({
  total: detailTotalCount.value,
  pageSize: detailRequestParams.value.size,
  current: detailRequestParams.value.page,
  showSizeChanger: true,
  showQuickJumper: true,
  pageSizeOptions: ['6', '10', '20', '30', '40', '50'],
}));

/* 查询 */
const detailSearchHandle = () => {
  dispatch(null, GET_RESERVERS_LIBRARY_DETAIL_PAGE);
};

/**
 * @description 表格选中事件
 */
const detailRowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
    selectedKeys.value = selectedRowKeys;
  },
};

const addRecord = (record, index) => {
  let msg = '',
    flag = true;

  isCrudEdit.value = false;
  detailPages.value.forEach((item, i) => {
    if (item.isAdd) {
      msg = '请先保存或取消您正在新增的数据';
      flag = false;
      return;
    }
    if (item.isEdit) {
      msg = '请先保存或取消您正在编辑的数据';
      flag = false;
      return;
    }
  });

  if (!flag) {
    return message.info(msg);
  }
  let addObj = {
    code: props.code,
    price: '',
    date: '',
    remark: '',
    isEdit: true,
    isAdd: true,
  };

  detailPages.value.splice(index, 0, addObj);
};
const editRecord = (record, index) => {
  selectedKeys.value = [record.id];
  isCrudEdit.value = false;
  let msg = '',
    flag = true;

  // detailPages.value.forEach((item, i) => {
  //   if (item.isAdd) {
  //     msg = '请先保存或取消您正在新增的数据';
  //     flag = false;
  //     return;
  //   }
  //   if (item.isEdit) {
  //     msg = '请先保存或取消您正在编辑的数据';
  //     flag = false;
  //     return;
  //   }
  // });

  // if (!flag) {
  //   return message.info(msg);
  // }
  record['old'] = JSON.parse(JSON.stringify(record)); // 备份原始数据
  record.isEdit = true;
};

/* 勾选编辑确认 */
const selectEditSumbit = () => {
  let record = [];

  detailPages.value.map((item) => {
    if (item.isAdd) {
      delete item.isAdd;
      delete item.isEdit;
      delete item.old;
      if (!item.commodity || item.commodity === '') {
        item.commodity = props.headerInfo[0].value
      }
      record.push(item);
    }
    for (let i = 0; i < selectedKeys.value.length; i++) {
      if (item.id === selectedKeys.value[i]) {
        // if (typeof item.date)
        delete item.isEdit;
        delete item.old;

        record.push(item);
      }
    }
  });
  editReservesApi(record[0]).then((res) => {
    confirmModalConf.visible = false;
    detailSearchHandle();
  });
};

// 勾选编辑
const selectEdit = () => {
  let record = [];

  detailPages.value.map((item) => {
    for (let i = 0; i < selectedKeys.value.length; i++) {
      if (item.id === selectedKeys.value[i]) {
        record.push(item);
      }
    }
  });

  isCrudEdit.value = false;
  record.map((item) => {
    item['old'] = JSON.parse(JSON.stringify(item)); // 备份原始数据
    item.isEdit = true;
  });
};
// 取消数据修改
const cancelRecord = (record, index) => {
  if (record.isAdd) {
    detailPages.value.splice(index, 1);
  } else {
    for (let i in record.old) {
      record[i] = record.old[i];
    }
    record.isEdit = false;
  }
};
// 保存数据修改
const saveRecord = (record, index) => {
  record.isEdit = false;
  record.isAdd = false;
  record.date = moment(record.date).format('YYYY-MM-DD');
};
// 开始删除
const delInfo = (ids) => {
  deleteReservesApi(ids).then((res) => {
    confirmModalConf.visible = false;
    detailSearchHandle();
  });
};
// 单行数据删除之前
const beforeDel = (ids) => {
  confirmModalConf.title = '确认删除项目？';
  confirmModalConf.callback = () => delInfo(ids);
  confirmModalConf.visible = true;
};
// 勾选删除
const selectDel = () => {
  const ids = selectedKeys.value;

  beforeDel(ids);
};
// 单行删除
const delRecord = (record) => {
  const { id } = record;

  beforeDel([id]);
};

// 详情页编辑、删除的权限控制
const detailOperationConf = [1, 2];

const detailTableOperationList = ref([]);

const detailTableOperationListConf = [
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-tianjia',
      title: '新增',
    },
    click: addRecord,
    operation: [1, 2, 3],
  },
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-bianjishuru',
      title: '编辑',
    },
    click: editRecord,
    operation: [1, 2],
  },
  // {
  //   option: {
  //     style: 'color: rgb(255, 200, 120)',
  //     class: 'iconfont icon-baocun',
  //     title: '保存',
  //   },
  //   click: saveRecord,
  //   operation: [1, 2,],
  // },
  // {
  //   option: {
  //     style: 'color: rgb(255, 200, 120)',
  //     class: 'iconfont icon-weibiaoti522',
  //     title: '取消',
  //   },
  //   click: cancelRecord,
  //   operation: [1, 2,],
  // },
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-shanchu',
      title: '删除',
    },
    click: delRecord,
    operation: [1, 2],
  },
];

// 详情页页码change事件
const detailChangePage = (page) => {
  commit(null, 'setDetailRequestParams', { code: props.code, page: page.current, size: page.pageSize });
  detailSearchHandle();
};

/**
 * @description 关闭通用弹窗
 */
const close = () => {
  confirmModalConf.visible = false;
  confirmModalConf.title = '';
};

/**
 * @description 确认通用弹窗
 */
const confirm = () => {
  confirmModalConf.callback();
};

onBeforeMount(() => {
  detailTableOperationList.value = detailTableOperationListConf
  commit(null, 'setDetailRequestParams', { code: props.code });
  detailSearchHandle();
});
</script>

<style lang="scss">
.reservesLibrary-detail-container {
  .detail-header {
    margin: 0.1rem;
    display: flex;
    justify-content: space-between;

    .detail-infotext {
      border-left: .04rem solid #f3a708;
      // width: 6.5rem;
      background-color: rgba(140, 100, 30, 0.2);
      display: flex;

      .detail-infotext-item {
        display: flex;
        margin: 0 0.05rem;

        .detail-infotext-label {
          color: rgba(255, 195, 76, 1);
        }
      }
    }

    .crud-wrapper {
      display: flex;

      // height: 0.51rem;
      // padding: 0.13rem 0.1rem;
      .crud-item {
        margin-right: 0.04rem;
        width: 0.5rem;
        color: #fff;
        // background-color: #efb227;
        background-image: url(~@/static/images/dataManagement/curd_btn.png);
        background-size: 100% 100%;
        text-align: center;
      }

      .crud-item:hover {
        cursor: pointer;
      }

      .crud-item-disabled {
        pointer-events: none;
        color: rgba(255, 255, 255, 0.6);
        // background-color: rgba(239, 178, 39, 0.6);
        opacity: 0.8;
      }

      .crud-item-disabled:hover {
        cursor: no-drop;
      }
    }
  }

  /* 表格样式修改 */
  .trend-detail-table {
    height: calc(100% - 0.84rem);

    .ant-spin-container {
      display: flex;
      flex-direction: column;
      align-items: end;
    }

    .ant-spin-nested-loading,
    .ant-spin-container,
    .ant-table-content {
      height: 100%;
    }

    .ant-table {
      height: calc(100% - .70rem);
      background: none;
      padding-left: 0.1rem;

      .ant-table-scroll {
        height: 100%;
        overflow: visible;
        overflow-x: visible;

        .ant-table-header {
          overflow: visible !important;
          margin-bottom: 0 !important;
        }
      }

      .ant-table-header {
        background: none;
      }

      .ant-table-body {
        overflow-x: hidden !important;
        overflow-y: auto !important;
        background: none;
      }

      /* 矿种 */
      .primary-commodity-img {
        width: 0.8rem;
        height: 0.6rem;
      }

      /* 图标 */
      .action-icons {
        i {
          font-size: 0.22rem;
          margin-right: 0.04rem;
          cursor: pointer;
        }
      }

      .ant-table-thead {
        border: .01rem solid #4d3f1c;
        border-radius: .10rem .10rem 0rem 0rem;
        background: none;
      }

      .ant-table-thead>tr>th {
        color: #ffc44d;
        background: rgba(179, 150, 92, 0.2);
        border: none;
      }

      .ant-table-tbody>tr>td {
        background-color: transparent;
        color: #fff;
        border-bottom: .01rem solid rgba(179, 150, 92, 1);
        vertical-align: middle;
      }

      .ant-table-placeholder {
        height: 100%;
        background-color: rgba(77, 63, 28, 1);
        border-top: rgba(179, 150, 92, 1);
        border-bottom: rgba(179, 150, 92, 1);
      }

      .ant-empty-normal {
        color: rgba(179, 150, 92, 1);
      }

      // 暂无数据填充样式
      // .ant-empty-img-simple-path {
      //   fill: rgba(77, 63, 28, 1);
      // }
      // .ant-empty-img-simple-ellipse {
      //   fill: rgba(77, 63, 28, 1);
      // }
      .ant-table-thead>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-tbody>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-thead>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
        background-color: rgba(179, 150, 92, 0.6);
      }

      .ant-table-thead>tr:hover.ant-table-row-selected>td,
      .ant-table-tbody>tr:hover.ant-table-row-selected>td {
        background-color: rgba(179, 150, 92, 0.6);
      }

      .ant-table-tbody>tr.ant-table-row-selected td {
        background-color: rgba(77, 63, 28, 1);
        color: #fff;
      }
    }
  }
}
</style>
